module.exports = __webpack_public_path__ + "static/media/Eclectic+Gallery+Wall+DIY+Tutorial_0010.3690f6f4.jpeg";